import { DataSource, Label, Layout, Panel, Table } from "@mcleod/components";

export abstract class AutogenLayoutScoreCardReasonCodesMapping extends Layout {
    labelReasonCodes: Label;
    reasonCodesPanel: Panel;
    sourceInterfaceCodes: DataSource;
    tableReasonCodesMapping: Table;
}
